import * as React from "react";

import { Box, Typography } from "@mui/material";
import Step from "@mui/material/Step";
import { StepIconProps } from "@mui/material/StepIcon";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import { FiHome, FiPackage, FiTruck } from "react-icons/fi";
import { RiShipLine } from "react-icons/ri";
import { SiLighthouse } from "react-icons/si";

import BadgeProgressStatus from "../../Generic/BadgeProgressStatus";
import { ProgressBarContainerEvent } from "../index";
import useStyles, { ColorlibConnector, ColorlibStepIconRoot } from "./styles";

interface StatusProgressBarProps {
  steps: ProgressBarContainerEvent[];
  activeStep: number;
}

function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, className, icon } = props;

  const renderIcon = (icon: React.ReactNode) => {
    switch (icon) {
      case "home":
        return <FiHome />;
      case "package":
        return <FiPackage />;
      case "truck":
        return <FiTruck />;
      case "port":
        return <SiLighthouse />;
      default:
        return <RiShipLine />;
    }
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {renderIcon(icon)}
    </ColorlibStepIconRoot>
  );
}

export default function ShipmentStatus({ steps, activeStep }: StatusProgressBarProps) {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
        {steps.map((step, index) => (
          <Step key={index}>
            <StepLabel
              StepIconProps={{
                icon: step.iconName,
              }}
              StepIconComponent={ColorlibStepIcon}
            >
              <Box
                style={{ height: "80%" }}
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"space-between"}
                justifyItems={"space-between"}
                alignItems={"center"}
              >
                <Typography noWrap className="typ-label">
                  {step.eventTypeDescription}
                </Typography>
                <Typography noWrap className="typ-date">
                  {step.eventLocationName}
                </Typography>
                <Typography noWrap className="typ-date">
                  {step.nextEventDateTime ? step.nextEventDateTime : "\u00A0"}
                </Typography>

                <BadgeProgressStatus value={step.status} />
              </Box>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
